export default __webpack_public_path__ + "static/media/sandbox.e8bfd691.svg";